// ABOUTME: Closing step of the standalone return, listing where every accepted item
// ABOUTME: was booked so the return desk knows which shelf to walk it to.
import { useTheme } from '@emotion/react';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { tokens } from '../../../../../theme';
import { getWarehouseLocationLabelData } from '../../../../../utils/labelColorText';
import ProgressionTab from '../../../../theme/ProgressionBuilder/ProgressionTab';
import ButtonGroup from '../../../../theme/buttons/ButtonGroup';
import Shbutton from '../../../../theme/buttons/Shbutton';
import ShLabel from '../../../../theme/label/ShLabel';
import Text from '../../../../theme/text/Text';

/**
 * TabContent1 Component
 *
 * Props:
 * - handleDataUpdate: Function, updates the data in the Redux state.
 * - handleNext: Function, navigates to the next tab.
 */
const Content = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    const colors = tokens(theme.palette.mode);
    const data = { ...props.data };

    // Filled in by the create response - the backend decides where the stock lands,
    // which is not always the location that was picked in the return lines.
    const locations = data.saveResult?.putBackLocations ?? [];

    return (
        <Box
            sx={{
                background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                display:"flex",
                flexDirection:"column",
                gap:1,
            }}
        >
            {locations.length === 0 &&
                <Text light>{t("nothing_to_put_back")}</Text>
            }

            {locations.map((placement, index) => {
                const labelData = getWarehouseLocationLabelData(placement.locationType, theme);
                return (
                <Box
                    key={"putback" + index}
                    sx={{
                        width:1,
                        background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],
                        display:"flex",
                        alignItems:'center',
                        justifyContent:'space-between',
                        gap:2,
                        px:2.5,
                        py:1,
                        borderRadius:3,
                        border:`1px solid ${colors.grey[100]}`,
                        boxShadow:`0px 2px 4px ${colors.grey[200]}`,
                    }}
                >
                    <Box
                        sx={{
                            display:"flex",
                            flexDirection:"column",
                        }}
                    >
                        <Text bold>{placement.sku}</Text>
                        <Text light>{placement.description}</Text>
                    </Box>
                    <Box
                        sx={{
                            display:"flex",
                            alignItems:'center',
                            gap:1,
                        }}
                    >
                        <Box
                            sx={{
                                height:32,
                                minWidth:32,
                                px:1.5,
                                display:"flex",
                                borderRadius:4,
                                alignItems:"center",
                                gap:0.5,
                                background:theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[100]
                            }}
                        >
                            <Text>{placement.amount}</Text>
                            <Text light>x</Text>
                        </Box>
                        <ShLabel borderless size={24} fitted variant={labelData.labelcolor} palette="normal">
                            {placement.location ?? t("unknown")}
                        </ShLabel>
                    </Box>
                </Box>
                );
            })}

            <Box
                sx={{
                    display:"flex",
                    justifyContent:"flex-end",
                    mt:1.5,
                }}
            >
                <ButtonGroup version={2}>
                    <Shbutton
                        className={"group-btn"}
                        color={theme.palette.mode === "dark" ? "blue" : "primary"}
                        onClick={props.handleClose}
                        variant="contained"
                        tabindex={1}
                        endIcon={<ArrowRightAltIcon/>}
                    >
                        {t("done")}
                    </Shbutton>
                </ButtonGroup>
            </Box>
        </Box>
    );
};

const PutBackOverview = (props) => {
    const {t} = useTranslation();

    return (
        <ProgressionTab
            tabId="tabPutBack"
            subtitle={t("put_back_products")}
            step={3}
            maxSteps={3}
            removeButtons
            sx={{
                body:{
                    borderRadius:6,
                }
            }}
        >
            <Content handleClose={props.handleClose}/>
        </ProgressionTab>
    )
}

export default PutBackOverview;
